import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@paperstac/cloud-functions/src/trpc';

export const trpc = createTRPCReact<AppRouter>();
